import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M256-200h64q17 0 28.5 11.5T360-160t-11.5 28.5T320-120H160q-17 0-28.5-11.5T120-160v-160q0-17 11.5-28.5T160-360t28.5 11.5T200-320v64l96-96q11-11 28-11t28 11 11 28-11 28zm448 0-96-96q-11-11-11-28t11-28 28-11 28 11l96 96v-64q0-17 11.5-28.5T800-360t28.5 11.5T840-320v160q0 17-11.5 28.5T800-120H640q-17 0-28.5-11.5T600-160t11.5-28.5T640-200zM200-704v64q0 17-11.5 28.5T160-600t-28.5-11.5T120-640v-160q0-17 11.5-28.5T160-840h160q17 0 28.5 11.5T360-800t-11.5 28.5T320-760h-64l96 96q11 11 11 28t-11 28-28 11-28-11zm560 0-96 96q-11 11-28 11t-28-11-11-28 11-28l96-96h-64q-17 0-28.5-11.5T600-800t11.5-28.5T640-840h160q17 0 28.5 11.5T840-800v160q0 17-11.5 28.5T800-600t-28.5-11.5T760-640z" }, null, -1)
  ])))
}
export default { render: render }